/* eslint-disable @typescript-eslint/no-explicit-any */
export type ConditionProps<T = any> = {
  onDelete?: () => void;
  conditionValue: T;
  updateConditionValue: (data: T) => void;
  asSummary?: boolean;
  displayValidation: boolean;
  disabled?: boolean;
};

export enum ClinicConditionalSegment {
  petSpecies = 'petSpecies',
  petAge = 'petAge',
  appointmentDate = 'appointmentDate',
  appointmentType = 'appointmentType',
}
export type SegmentDefinition = { segmentId: string; definitionVariables: { staticVariables: unknown } };

export enum SegmentPetAgeUnit {
  days = 'days',
  months = 'months',
  years = 'years',
}

export enum SegmentPetAgeYoungerOrOlder {
  younger = 'younger',
  older = 'older',
}

export type EmailCampaignSegmentDefinition = { conditionalSegments?: SegmentDefinition[] };

export type AvailableSegments = Record<
  ClinicConditionalSegment,
  {
    segmentId: string;
    name: ClinicConditionalSegment;
    label: string;
    component: (props: any) => JSX.Element;
    initialValues: unknown;
    parser?: (data: any) => unknown;
    hasValidData: (data: any) => boolean;
  }
>;
